
import { timeRangeOptions, saleOrderStatus, stateOptionBoolean } from "@/utils/options";
import { TransferOrderEnum } from "modules/warehouse/transfer-order/enum";

const dateTypeOptions = [
    {id: 'ExpectShipmentDate', text: '预计出运日期'},
    {id: 'CreateTime', text: '创建时间'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '调出仓',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            placeholder: '调出仓',
            fba: false,
            multiple: true
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
},{
    label: '调入仓',
    prop: 'arrivalWarehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'arrivalWarehouseIds',
        propsData: {
            placeholder: '调入仓',
            multiple: true
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '状态',
    prop: 'statusList',
    components: [{
        name: 'gj-select',
        prop: 'statusList',
        propsData: {
            placeholder: '状态',
            options: TransferOrderEnum.statusOption,
            multiple: true,
            collapseTags: true
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '国家店铺',
    prop: 'countryMarket',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarket'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '创建人',
    prop: 'createUser',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-creator-select',
        prop: 'createUser',
        propsData: {
            placeholder: '创建人'
        }
    }],
    defaultValue: ''
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'ExpectShipmentDate'
}]
